import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import URLParse from 'url-parse';

const useFrameLoadEnsurer = frameRef => {
	const [frame, setFrame] = useState(null);

	useEffect(() => {
		const frameEl = frameRef.current;
		const loadHandler = () => setFrame(frameEl);

		frameEl.addEventListener('load', loadHandler);
		return () => frameEl.removeEventListener('load', loadHandler);
	});

	return frame;
};

const Preview = props => {
	const { data, className, url } = props;
	const iframeRef = React.createRef();
	const { origin } = URLParse(url);
	const frameEl = useFrameLoadEnsurer(iframeRef);

	if (frameEl) {
		frameEl.contentWindow.postMessage(data, origin);
	}

	return (
		<div className="branded-tracking-preview">
			<div className={className}>
				<div className="device-frame">
					<iframe title="spPreview" src={url} ref={iframeRef} />
				</div>
			</div>
		</div>
	);
};

Preview.propTypes = {
	data: PropTypes.object.isRequired,
	url: PropTypes.string.isRequired,
	className: PropTypes.string,
};

export default Preview;
